module.exports = __webpack_public_path__ + "static/img/位置大数据_1.db1529b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/位置大数据_1.jpg
// module id = K9QO
// module chunks = 1